<template>
  <div v-swiper="swiperOption" class="relative latests-resources-swiper rounded-t-md">
    <div class="swiper-wrapper">
      <slot name="slides" />
    </div>
    <div class="arrows-wrap">
      <span class="mr-4 counter sm:mr-0 sm:ml-auto"> {{ current }} / {{ total }} </span>
      <button class="ml-auto mr-4 arrows sm:mx-6 previous-btn">
        <img src="../../images/prev.svg" alt="Previous" />
      </button>
      <button class="arrows next-btn">
        <img src="../../images/next.svg" alt="Next" />
      </button>
    </div>
  </div>
</template>

<script>
import { directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import padStart from 'lodash/padStart';

export default {
  directives: {
    swiper: directive
  },

  data() {
    const self = this;

    return {
      currentSlide: 1,
      totalSlides: 1,
      swiperOption: {
        autoplay: {
          delay: 8000,
          loop: true,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.latests-resources-swiper .next-btn',
          prevEl: '.latests-resources-swiper .previous-btn'
        },
        on: {
          init() {
            self.totalSlides = this.slides.filter(
              (_, slide) => !slide.classList.contains('swiper-slide-duplicate')
            ).length;
          },
          slideChange() {
            self.currentSlide = this.realIndex + 1;
          }
        }
      }
    };
  },

  computed: {
    current() {
      return padStart(this.currentSlide, 2, '0');
    },
    total() {
      return padStart(this.totalSlides, 2, '0');
    }
  }
};
</script>

<style lang="scss">
.arrows.swiper-button-disabled {
  @apply border-gray-base;
  @apply opacity-50;
  @apply pointer-events-none;
  @apply outline-none;

  &:focus,
  &:active {
    @apply outline-none;
  }
}

.arrows-wrap {
  @apply flex items-center;
  @apply absolute left-0 top-0 z-10;
  @apply pr-1;

  background-color: #fafdff;

  top: 40vw;

  @screen xs {
    top: 12.25rem;
  }

  @screen sm {
    @apply left-auto right-0;
    top: 16.75rem;
  }

  @screen md {
    top: 20.75rem;
  }

  @screen lg {
    top: 24.25rem;
  }

  @screen xl {
    top: 30rem;
  }
}
</style>
